import { useEffect, useState } from "react";

export interface TocItem {
  id: string;
  label: string;
}

export default function EventToc({ items }: { items: TocItem[] }) {
  const [activeId, setActiveId] = useState(items[0]?.id ?? "");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin: "-130px 0px -60% 0px", threshold: 0 },
    );

    items.forEach((item) => {
      const element = document.getElementById(item.id);
      if (element) {
        observer.observe(element);
      }
    });

    return () => observer.disconnect();
  }, [items]);

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    event.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      aria-label="本文目录"
      className="rounded-lg border border-background-200 bg-background-50 p-5"
    >
      <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.15em] text-foreground-500">
        <i className="ri-list-check-2"></i>
        本文目录
      </p>
      <ul className="mt-4 space-y-1">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              onClick={(event) => handleClick(event, item.id)}
              className={`block rounded-md border-l-2 px-3 py-2 text-sm transition-colors ${
                activeId === item.id
                  ? "border-primary-500 bg-primary-50 font-medium text-primary-700"
                  : "border-transparent text-foreground-600 hover:border-background-300 hover:text-foreground-900"
              }`}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}